module.exports = __webpack_public_path__ + "img/chevron-down.c7ea2d9a.svg";